import React from 'react';
import {FormDialog, RaymanUser, UserSize} from 'components/core';
import {UsersCtx} from 'components/dataProviders/users';
import {TagsCtx} from 'components/dataProviders/tags';
import {ChannelsCtx} from 'components/dataProviders/channels';
import Singletons from 'controllers/Singletons';


export default function Create({open, onClose})
{
    const usersCtx = React.useContext(UsersCtx);
    const tagsCtx = React.useContext(TagsCtx);
    const channelsCtx = React.useContext(ChannelsCtx);
    const [loading, setLoading] = React.useState(false);
    const [tagItems, setTagItems] = React.useState([]);
    const [userItems, setUserItems] = React.useState([]);

    React.useEffect(function InitializeUsers() {
      let users = [];

      usersCtx.data.array.forEach((item) => {
        if(item.disabled === false) users.push(
          {
            value: item.userID,
            content: <RaymanUser userID={item.userID} size={UserSize.size24} />
          }
        )
      });
      setUserItems(users);

    }, [usersCtx]);

      React.useEffect(function initializeTags() {
        let tags = [];
        tagsCtx.data.active.forEach((item) => tags.push({value: item.tagID, content: item.name}));
  
        setTagItems(tags);
    }, [tagsCtx]);

    const handleClose = () => {
        if(onClose) onClose();
      };
  
      const handleConfirm = (values) => {

        setLoading(true);
        channelsCtx.funcs.create(values).then(() => {
          setLoading(false);
          handleClose();
        });
      }

    return <FormDialog
    open={open}
    onClose={handleClose}
    onConfirm={handleConfirm}
    title="Crear Canal"
    subtitle="Añade un nombre al canal y selecciona usuarios para incluir"
    confirm="Crear Canal"
    cancel="Cancelar"
    loading={loading}
    fields={[
      {
        type: "text",
        label: "Nombre del canal",
        id: "name",
        placeholder: "",
        mandatory: true,
        value: ''
      },
      {
        type: "multiselector",
        label: "Usuarios invitados",
        id: "users",
        value: [],
        items: userItems
    },
      {
        type: "tagSelector",
        label: "Añadir etiquetas",
        id: "tags",
        value: [],
        items: tagItems
      }
    ]}
    />
}